// Visuels de marque Ronalp Enseigne (photos fournies par le client).
// Noms de fichiers descriptifs pour le SEO images.
const BRAND = {
  caissonFacade: "/img/ronalp-caisson-lumineux-facade.png",
  enseigneDrapeau: "/img/ronalp-enseigne-drapeau-led.png",
  lettreBoitier: "/img/ronalp-lettre-boitier-fabrication.png",
  lettresRelief: "/img/ronalp-lettres-relief-retroeclairage.png",
  lettresLumineuses: "/img/ronalp-lettres-lumineuses-led.png",
  enseigneFacadeNuit: "/img/ronalp-enseigne-lumineuse-facade-nuit.png",
};

// Les clés historiques sont conservées et pointent vers les visuels de marque,
// afin que toutes les pages existantes utilisent automatiquement les vraies photos.
export const IMAGES = {
  storefrontNight: BRAND.enseigneFacadeNuit,
  storefront2: BRAND.enseigneDrapeau,
  workshopWelding: BRAND.lettreBoitier,
  craftsmanCutting: BRAND.lettreBoitier,
  neonWorkshop: BRAND.lettresLumineuses,
  facade: BRAND.lettresRelief,
  commercial: BRAND.caissonFacade,
  // alias explicites
  caissonFacade: BRAND.caissonFacade,
  enseigneDrapeau: BRAND.enseigneDrapeau,
  lettreBoitier: BRAND.lettreBoitier,
  lettresRelief: BRAND.lettresRelief,
  lettresLumineuses: BRAND.lettresLumineuses,
  enseigneFacadeNuit: BRAND.enseigneFacadeNuit,
};

export const IMAGE_LIST = Object.values(BRAND);
